const filters = {

    'filters.waiting.sync': 'Warten auf Synchronisierung',
    'filters.adjusted.synced': 'Angepasst und synchronisiert',

    'filters.adjusted.show': 'Show in webshop is adjusted',
    'filters.adjusted.name': 'Name is adjusted',
    'filters.adjusted.price': 'Price is adjusted',
    'filters.adjusted.unique_code': 'Product number is adjusted',
    'filters.adjusted.category': 'Category is adjusted',
    'filters.adjusted.additional_categories': 'Additional categories are set',
    'filters.adjusted.seo': 'SEO is adjusted',

    'filters.remove': 'Filteroptionen entfernen',

    'filters.product.types.critical': 'Kritisch',
    'filters.product.types.info': 'Info',

    'filters.product.jobs.collect': 'Sammeln',
    'filters.product.jobs.connect': 'Verbinden',
    'filters.product.jobs.sync': 'Synchronisieren',


};

export default filters;
